import React, { Component } from 'react'
import Geosuggest from 'react-geosuggest'
import scriptLoader from 'react-async-script-loader'
import { GOOGLE_API_KEY } from 'constants/ResourcesConstants'

require('./style.styl')

class LocationSearch extends Component {
  state = {
    ready: false
  }

  componentWillReceiveProps ({ isScriptLoaded, isScriptLoadSucceed }) {
    if (isScriptLoaded && !this.props.isScriptLoaded) { // load finished
      if (isScriptLoadSucceed) {
        this.setState({ ready: true })
      }
      // Else I dunno bro shit is broken that is what else
      else {

      }
    }
  }

  render() {
    return this.state.ready ? (
      <Geosuggest
        {...this.props}
        onChange={label => {
          if (label === '') {
            this.props.selectDefault()
          }
        }}
      />
    ) : (
      <div />
    )
  }
}

export default scriptLoader(
  `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places`
)(LocationSearch)



// WEBPACK FOOTER //
// ./src/scripts/components/shared/LocationSearch/index.js